import { PencilIcon } from "lucide-react";
import { DefaultActionBuilder } from "../types/actions";

export const actionEdit: DefaultActionBuilder = (onAction, options) => {
  return {
    id: "edit",
    label: "Edit",
    icon: PencilIcon,
    allowInline: true,
    onAction,
    ...options
  };
};
